import { isElementSizeEqual } from './isElementSizeEqual';
import { isElementPositionEqual } from './isElementPositionEqual';
export function isElementBoundaryEqual(a, b) {
  return isElementSizeEqual(a, b) && isElementPositionEqual(a, b);
}